// src/app/services/user.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ENDPOINTS } from '@/app/common/constants';
import { GET_METHOD, PUT_METHOD } from '../helpers/utils';
@Injectable({ providedIn: 'root' })
export class BellNotificationsService {

  constructor() { }

  private ameroNotificationsSubject = new BehaviorSubject<any>([]);
  ameroNotifications$: Observable<any> = this.ameroNotificationsSubject.asObservable();

  private servicesNotificationSubject = new BehaviorSubject<any>([]);
  servicesNotification$: Observable<any> = this.servicesNotificationSubject.asObservable();

  private sendsNotificationsSubject = new BehaviorSubject<any>([]);
  sendsNotifications$: Observable<any> = this.sendsNotificationsSubject.asObservable();

  async getAmeroNotifications(): Promise<void> {
    this.ameroNotificationsSubject.next([]);

    await GET_METHOD(ENDPOINTS.ameroNotifications, true).then((response: any) => {
      this.ameroNotificationsSubject.next(response.data);
    })
  }
  async getServicesNotifications(): Promise<void> {
    this.servicesNotificationSubject.next([]);

    await GET_METHOD(ENDPOINTS.servicesNotifications, true).then((response: any) => {
      this.servicesNotificationSubject.next(response.data);
    })
  }

  async getSendsNotifications(): Promise<void> {
    this.sendsNotificationsSubject.next([]);

    await GET_METHOD(ENDPOINTS.sendsNotifications, true).then((response: any) => {
      this.sendsNotificationsSubject.next(response.data);
    })
  }

  async readNotification(id: number): Promise<void> {

    await PUT_METHOD(ENDPOINTS.readNotification(id), true, null).then((response: any) => {
      console.log(response);
    })
  }


}